import * as React from 'react';

import { Viewport, ViewSmall, ViewLarge } from 'bernie-view';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { TravelerOptionsDialog, TravelerOptionsMenu } from '.';
import { InteractableFieldComponentProps } from 'types/shared';

export const TravelerOptions = ({ onFieldInteraction }: InteractableFieldComponentProps) => (
  <Viewport>
    <ViewSmall>
      <UitkLayoutGridItem colSpan={{ small: 2, medium: 1 }}>
        <div data-test-id="traveler-options-dialog-trigger">
          <TravelerOptionsDialog onFieldInteraction={onFieldInteraction} />
        </div>
      </UitkLayoutGridItem>
    </ViewSmall>
    <ViewLarge>
      <TravelerOptionsMenu onFieldInteraction={onFieldInteraction} />
    </ViewLarge>
  </Viewport>
);
